import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { IAnnotation } from '@ahryman40k/ts-fhir-types/lib/R4';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AbstractAddComponent } from '../../../../../shared/abstracts/add/abstract-add/abstract-add.component';

@Component({
  selector: 'inc-alert-comment-add',
  templateUrl: './alert-comment-add.component.html',
  styleUrls: ['./alert-comment-add.component.scss'],
})
export class AlertCommentAddComponent extends AbstractAddComponent<IAnnotation> implements OnInit, OnDestroy {
  @Input() user: any;
  @Output() callCancel: EventEmitter<null> = new EventEmitter();
  @Output() callSaveAndApprove: EventEmitter<IAnnotation> = new EventEmitter();

  form: FormGroup;
  interval: any;
  actualTime: Date;

  placeholder = 'ADD_NEW_COMMENT';

  constructor() { super(); }

  ngOnInit() {
    if (!this.inData) {
      this.refreshTime();
      this.interval = setInterval(() => {
        this.refreshTime();
      }, 1000);
      if (this.user) {
        this.form.get('authorReference').setValue({
          reference: this.user.uid,
          display: this.user.displayName
        });
      }
    } else {
      this.form.patchValue(this.inData);
      this.placeholder = 'UPDATE_EXISTING_COMMENT';
    }
  }

  ngOnDestroy() { clearInterval(this.interval); }

  close(data?: IAnnotation) {
    if (data && data.text) {
      this.save(data);
    } else {
      this.callCancel.emit();
    }
  }

  resetForm(): FormGroup {
    return new FormGroup({
      authorReference: new FormGroup({
        reference: new FormControl(''),
        display: new FormControl('')
      }),
      text: new FormControl('', Validators.required),
      time: new FormControl('')
    });
  }

  refreshTime(): void {
    this.actualTime = new Date();
    this.form.controls.time.setValue(this.actualTime.toISOString());
  }

  saveAndApprove(data: IAnnotation): void {
    this.callSaveAndApprove.emit(data);
  }
}
